import { ExternalAccountInvitation, InvitationStatus } from "@shared/types";
import StatusTag from "common/Tags/StatusTag.tsx";
import React from "react";
import { useTheme } from "styled-components";

interface InvitationStatusProps {
  invitation: ExternalAccountInvitation;
}

const InvitationStatusTag = ({ invitation }: InvitationStatusProps) => {
  const theme = useTheme();

  let color = theme.colors.green;
  let text = "Active";
  if (invitation.status === InvitationStatus.EXPIRED) {
    color = theme.colors.red;
    text = "Expired";
  } else if (invitation.status === InvitationStatus.USED) {
    color = theme.colors.primaryBlue;
    text = "Used";
  }

  return (
    <StatusTag
      text={text}
      color={color}
      animated={false}
      style={{ width: "fit-content" }}
    />
  );
};

export default InvitationStatusTag;
